import axios from 'axios';
//import http from '../../http';
import { UPDATE_USER, UPDATE_PROFILE, RECAPTCHA_TOKEN_FIELD } from '../../enums';

export const updateProfile = async (loggedInUser, profileUpdates, recaptchaResult) => {

  const {id, token, profiles} = loggedInUser;
  const {allow_marketing, allow_third_party} = profileUpdates;

  const updateUser = {
    allow_marketing, 
    allow_third_party
  }

  const updateProfile = {
    id: profiles.data[0].id,
    [RECAPTCHA_TOKEN_FIELD]: recaptchaResult,
    ...profileUpdates
  }

  const userUpdateResult = await axios({
    headers: {
      Authorization: `Bearer ${token}`
    },
    method: 'PATCH',
    url: UPDATE_USER(id),
    data: updateUser
  });

  const profileUpdateResult = await axios({
    headers: {
      Authorization: `Bearer ${token}`
    },
    method: 'PATCH',
    url: UPDATE_PROFILE(profiles.data[0].id),
    data: updateProfile
  })

  return {
    userUpdateResult,
    profileUpdateResult
  }

} 